// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_2Bjsj_hRfNfg","icon":"_2OuW3D_wZds1"};